import { useCreateDataTableOptions } from "@/components/data-table/hooks/useCreateDataTableOptions";
import { useDynamicQueryParams } from "@/hooks/useDynamicQueryParams";
import { EmailRecipientsService } from "@/services/emailRecipients";
import { DisplayEmailRecipient } from "@/types/emailRecipient";
import { keepPreviousData, useInfiniteQuery } from "@tanstack/react-query";

export const useEmailRecipientsQuery = ({
  emailTypeId,
  enabled = true,
  name = "emailRecipients",
}: {
  emailTypeId?: string;
  enabled?: boolean;
  name?: string;
}) => {
  const options = useCreateDataTableOptions<DisplayEmailRecipient>(name);
  const queryKeyBase = emailTypeId ? [name, emailTypeId] : [name];
  const queryKey = useDynamicQueryParams(queryKeyBase, options);
  const query = useInfiniteQuery({
    queryKey,
    queryFn: ({ pageParam }) => {
      if (!emailTypeId) {
        throw new Error("emailTypeId is required to fetch recipients");
      }

      return EmailRecipientsService.getRecipients(emailTypeId, {
        lastItem: pageParam,
        filters: options.filters,
        sorting: options.sorting[0],
      });
    },
    initialPageParam: undefined,
    getNextPageParam: ({ last_item }) => last_item,
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    enabled: enabled && Boolean(emailTypeId),
  });

  return {
    query,
    options,
    queryKey,
  };
};
